import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import type { MarketplaceConfig } from "@slfinrtl/feature-config"
import { useMemo } from "react"
// eslint-disable-next-line no-restricted-imports -- this hook is the sanctioned wrapper around getMarketplaceConfig
import { getMarketplaceConfig } from "src/common/getConfig"

export type Config = MarketplaceConfig

export const useConfig = (): Config => {
	const { marketplaceKey } = useDealerContext()
	return useMemo(() => getMarketplaceConfig(marketplaceKey), [marketplaceKey])
}
